import { render } from "./Lock.vue?vue&type=template&id=3dc7bd0a"
const script = {}

import exportComponent from "/Users/theimer/Developer/laravel/nova-medialibrary-field/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__